// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Zc","heading":"_c","items":"ad","featureCss":"bd","disabled":"cd","imgCss":"dd"};